<template>
  <div id="searching-for-annimation"></div>
</template>

<script>
  import { Config } from '../../game/Config';
  import * as PIXI from 'pixi.js';
  import { animationPaths } from '../../assetsPath';

  let animation, configInstance, app;

  export default {
    name: 'SearchingOpponentsAnimation',
    data() {
      return {};
    },

    async mounted() {
      app = new PIXI.Application({ backgroundAlpha: 0 });
      // document.body.appendChild(app.view);

      configInstance = new Config(true);

      app.view.width = configInstance.uiConstants.width / 3;
      app.view.height = configInstance.uiConstants.height / 3;
      document.getElementById('searching-for-annimation').appendChild(app.view);

      /**
       * @type Spritesheet
       */
      let spriteSheet = PIXI.Cache.get(animationPaths[1]);

      if (!spriteSheet) {
        spriteSheet = await PIXI.Assets.load(animationPaths[1]);
      }

      let searchingSpriteSheet = [];

      let searchingSpriteSheetImage = spriteSheet.data.animations;
      for (const character in searchingSpriteSheetImage) {
        const characterFileName = searchingSpriteSheetImage[character];

        for (const filename of characterFileName) {
          searchingSpriteSheet.push(filename);
        }
      }

      animation = PIXI.AnimatedSprite.fromFrames(searchingSpriteSheet);

      animation.position.x = 0;
      animation.position.y = 2;
      animation.loop = true;
      animation.width = configInstance.uiConstants.width / 3;
      animation.height = configInstance.uiConstants.width / 3;

      //  TODO : ask for animation speed
      animation.animationSpeed = 1 / 8;

      if (app.stage) {
        app.stage.addChild(animation);
        animation.play();
      }

      window.addEventListener('resize', this.onWindowResize);
    },
    unmounted() {
      window.removeEventListener('resize', this.onWindowResize);
      if (app) {
        app.destroy();
      }
    },
    components: {},
    methods: {
      onWindowResize() {
        configInstance = new Config(true);
        animation.width = configInstance.uiConstants.width / 3;
        animation.height = configInstance.uiConstants.width / 3;

        app.view.width = configInstance.uiConstants.width / 3;
        app.view.height = configInstance.uiConstants.height / 3;
      },
    },
  };
</script>
